import BaseModel from '../BaseModel';

export default class VacancyContactPerson extends BaseModel {
  static entity = 'vacancyContactPersons';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      vacancyId: this.attr(null),
      name: this.string(null).nullable(),
      phone: this.string(null).nullable(),
      email: this.string(null).nullable(),
      comment: this.string(null).nullable(),
    };
  }
}
